<script setup>
import {useSystem} from "../../store/system";
import {useArticles} from "../../store/articles";
import {useRouter} from "vue-router";
import {onActivated, onMounted} from "vue";

const router = useRouter()
const systemStore = useSystem()
const articleStore = useArticles()
articleStore.articlesListApi()

onActivated(() => {
  document.title = 'Latest Crypto Mining News & Trends | HexMiner Blog';
  document.querySelector('meta[name="description"]').setAttribute('content', 'Stay updated on Bitcoin cloud mining, Dogecoin mining, and\n' +
      'AI-powered innovations. Expert insights from HexMiner.');
})
</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div class="section__title">
              <h1>{{systemStore.getFrontModuleContent(14).title}}</h1>
<!--              <p>Here, you'll find a curated collection of articles, analysis, and expert opinions that keep you ahead of the curve.</p>-->
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- news -->
    <div class="section">
      <div class="container">
        <div class="row">
          <!-- post -->
          <div class="col-12 col-md-12 col-lg-6" v-for="(item, index) in articleStore.getArticlesList" :key="index" @click="router.push({path: '/Article', query:{article_id: item.id}})">
            <div class="post cursor-pointer shadow-md shadow-[rgba(160,52,250,0.15)]">
              <div class="post__img cursor-pointer">
                <el-image class="h-full" :src="image" fit="cover" v-for="(image, idx) in item.images_list" :key="idx"></el-image>
              </div>

              <div class="post__content">
<!--                <a href="#" class="post__category">NFT</a>-->
                <h3 class="post__title p-0">{{item.title}}</h3>
<!--                <div class="post__meta">-->
<!--                  <span class="post__date"><i class="ti ti-calendar-up"></i> 25.06.23</span>-->
<!--                  <span class="post__views"><i class="ti ti-eye"></i> 17</span>-->
<!--                </div>-->
              </div>
            </div>
          </div>
          <!-- end post -->
        </div>

<!--        <div class="row">-->
<!--          &lt;!&ndash; paginator &ndash;&gt;-->
<!--          <div class="col-12">-->
<!--            <div class="paginator">-->
<!--              <span class="paginator__pages">10 from 183</span>-->

<!--              <ul class="paginator__list-mobile">-->
<!--                <li>-->
<!--                  <a href="#">-->
<!--                    <i class="ti ti-arrow-left"></i>-->
<!--                    <span>Prev</span>-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <a href="#">-->
<!--                    <span>Next</span>-->
<!--                    <i class="ti ti-arrow-right"></i>-->
<!--                  </a>-->
<!--                </li>-->
<!--              </ul>-->

<!--              <ul class="paginator__list">-->
<!--                <li>-->
<!--                  <a href="#"><i class="ti ti-arrow-left"></i></a>-->
<!--                </li>-->
<!--                <li><a href="#">1</a></li>-->
<!--                <li class="active"><a href="#">2</a></li>-->
<!--                <li><a href="#">3</a></li>-->
<!--                <li><a href="#">4</a></li>-->
<!--                <li><span>...</span></li>-->
<!--                <li><a href="#">18</a></li>-->
<!--                <li><a href="#">19</a></li>-->
<!--                <li>-->
<!--                  <a href="#"><i class="ti ti-arrow-right"></i></a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; end paginator &ndash;&gt;-->
<!--        </div>-->
      </div>
    </div>
    <!-- end news -->

  </div>
</template>

<style scoped>

</style>
